import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description PercentHouse icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { PercentHouse } from '@sravni/design-system-icons'
 *
 * <PercentHouse />
 * ```
 */
var PercentHouse = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "PercentHouse", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m2.403 9.444 7.598-6.927a1.064 1.064 0 0 1 1.471 0l7.598 6.927", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round" }),
    React.createElement("path", { d: "M17.736 8v8.572c0 .789-.626 1.428-1.4 1.428h-11.2c-.773 0-1.4-.64-1.4-1.428V8", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("g", { clipPath: "url(#PercentHouse__a)", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "m13.736 9-6 6M8.486 10.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.977 14.99a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "PercentHouse__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(6.736 8)", d: "M0 0h8v8H0z" }))))); });

export { PercentHouse };
//# sourceMappingURL=PercentHouse.js.map
